/* eslint-disable no-console */

export function getFromLS(fieldName) {
  if (typeof window === 'undefined') return null;

  try {
    const value = localStorage.getItem(fieldName);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error(`Error getting ${fieldName} from localStorage:`, error);
    return null;
  }
}

export function setToLS(fieldName, value) {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(fieldName, JSON.stringify(value));
  } catch (error) {
    console.error(`Error setting ${fieldName} in localStorage:`, error);
  }
}

export function removeFromLS(fieldName) {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(fieldName);
  } catch (error) {
    console.error(`Error getting ${fieldName} from localStorage:`, error);
  }
}

export function clearLocalStorageKeys(keys: string[]): void {
  keys.forEach(key => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Failed to remove key "${key}" from localStorage:`, error);
    }
  });
}

export function clearLocalStorageExcept(substring: string): void {
  const keysToRemove: string[] = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && !key.includes(substring)) {
      keysToRemove.push(key);
    }
  }

  for (const key of keysToRemove) {
    localStorage.removeItem(key);
  }
}
